import { render, staticRenderFns } from "./QuotaMeter.vue?vue&type=template&id=47889573&scoped=true&"
import script from "./QuotaMeter.vue?vue&type=script&lang=js&"
export * from "./QuotaMeter.vue?vue&type=script&lang=js&"
import style0 from "./QuotaMeter.vue?vue&type=style&index=0&id=47889573&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47889573",
  null
  
)

export default component.exports